/**
 * Get the URL suffix from a given URL string
 * @param url The full URL string
 * @returns The last part of the URL string
 */
export const getUrlSuffix = (url: string): string => {
	const pathSegments = url.split('/');
	return pathSegments[pathSegments.length - 1] as string;
};
